import React from 'react';
import { ClientUser } from '../types';
import styled from '@emotion/styled';
import { EditIcon } from '../../../components/icons';
import NotificationToolTip from './NotificationToolTip';

interface IProps {
  clientUser: ClientUser;
  onEditClick: () => void;
}

const EditStyles = styled.div`
  position: absolute;
  right: 55px;
  top: 30px;
  cursor: pointer;
`;

export default function InfoRow(props: IProps) {
  const [showTooltip, setShowTooltip] = React.useState(false);
  return (
    <React.Fragment>
      <div style={{ fontWeight: 700 }}>
        {props.clientUser.firstName} {props.clientUser.lastName}
      </div>
      <div>{props.clientUser.email}</div>
      <div>{props.clientUser.roleOption.label}</div>
      {/* @ts-ignore */}
      <div style={{color:'#e3e1df'}}>
      {/* this is for style underneath cursor: props.clientUser.contactNotificationTypes.length > 0 ? 'pointer' :'auto', */}
      <div
        style={{ textDecoration: 'underline'}}
        // onMouseEnter={() => setShowTooltip(true)}
        // onMouseLeave={() => setShowTooltip(false)}
      >
        {props.clientUser.contactNotificationTypes.length} notifications{' '}
        {showTooltip && props.clientUser.contactNotificationTypes.length > 0 && <NotificationToolTip notifications={props.clientUser.contactNotificationTypes} />}
      </div>
      </div>
      <EditStyles onClick={props.onEditClick}>
        <EditIcon stroke="#E5E5EA" />
      </EditStyles>
    </React.Fragment>
  );
}
